import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { SummarizeComponent } from './summarize/summarize.component';
import { SummarizeRoutingModule } from './summarize-routing.module';
import { AuthGuardService } from 'app/auth-guard.service';
import { SummarizeService } from './summarize.service';
import { HttpClientModule } from '@angular/common/http';
import { PageHeaderComponent } from '../page-header/page-header.component';
import { SharedModule } from 'app/shared/shared.module';
import { NgxDocViewerModule } from 'ngx-doc-viewer';
import { SummarizeDataListComponent } from './summarize-data-list/summarize-data-list.component';
import { SummarizeContentComponent } from './summarize-content/summarize-content.component';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { LlmService } from 'app/services/llm.service';



@NgModule({
  declarations: [
    SummarizeComponent,
    SummarizeDataListComponent,
    SummarizeContentComponent,
     
  ],
  imports: [
    CommonModule,
    SummarizeRoutingModule,
    SharedModule,
    HttpClientModule,
    NgxDocViewerModule,
    FormsModule,
    ReactiveFormsModule
  ],
  providers:[AuthGuardService,SummarizeService,LlmService]
})
export class SummarizeModule { }
